import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function t(t) {
  return "function" == typeof t;
}

function e(e, r, n, a) {
  return t(e) ? e(r, n, a) : e;
}

function r(t) {
  return [t.r, t.g, t.b, t.a];
}

function n(t, e, r) {
  var n = " /-,\n",
      o = function o(t) {
    var e = t.length;

    for (; e--;) {
      if (-1 === n.indexOf(t.charAt(e))) return !1;
    }

    return !0;
  },
      i = [];

  var l = 0,
      c = -1;

  do {
    if (c = e.indexOf("[", l), c >= l) {
      if (c > l) {
        var _t = e.substr(l, c - l);

        i.push([_t, null, o(_t)]);
      }

      if (l = c + 1, c = e.indexOf("]", l), c >= l) {
        if (c > l) {
          var _r = t[e.substr(l, c - l)];
          _r && i.push([null, _r, !1]);
        }

        l = c + 1;
      }
    }
  } while (-1 !== c);

  if (l < e.length - 1) {
    var _t2 = e.substr(l);

    i.push([_t2, null, o(_t2)]);
  }

  return function (t) {
    var e = "",
        n = null;

    var _iterator = _createForOfIteratorHelper(i),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r2 = _step.value;

        var _r3 = _slicedToArray(_r2, 3),
            _a = _r3[0],
            _o = _r3[1],
            _i = _r3[2];

        if (_a) _i ? n = _a : (n && (e += n, n = null), e += _a);else {
          var _r4 = t.attributes[_o];
          _r4 && (n && (e += n, n = null), e += _r4);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return a(e, r);
  };
}

function a(t, e) {
  switch ("string" != typeof t && (t = String(t)), e) {
    case "LowerCase":
      return t.toLowerCase();

    case "Allcaps":
      return t.toUpperCase();

    default:
      return t;
  }
}

function o(t, e, r, n, a, o) {
  var i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !0;
  var l = e / a,
      c = r / o,
      u = Math.ceil(l / 2),
      s = Math.ceil(c / 2);

  for (var _M = 0; _M < o; _M++) {
    for (var _r5 = 0; _r5 < a; _r5++) {
      var _f = 4 * (_r5 + (i ? o - _M - 1 : _M) * a);

      var _p = 0,
          C = 0,
          y = 0,
          I = 0,
          h = 0,
          k = 0,
          d = 0;
      var P = (_M + .5) * c;

      for (var _n = Math.floor(_M * c); _n < (_M + 1) * c; _n++) {
        var _a2 = Math.abs(P - (_n + .5)) / s,
            _o2 = (_r5 + .5) * l,
            _i2 = _a2 * _a2;

        for (var _c = Math.floor(_r5 * l); _c < (_r5 + 1) * l; _c++) {
          var _r6 = Math.abs(_o2 - (_c + .5)) / u;

          var _a3 = Math.sqrt(_i2 + _r6 * _r6);

          _a3 >= -1 && _a3 <= 1 && (_p = 2 * _a3 * _a3 * _a3 - 3 * _a3 * _a3 + 1, _p > 0 && (_r6 = 4 * (_c + _n * e), d += _p * t[_r6 + 3], y += _p, t[_r6 + 3] < 255 && (_p = _p * t[_r6 + 3] / 250), I += _p * t[_r6], h += _p * t[_r6 + 1], k += _p * t[_r6 + 2], C += _p));
        }
      }

      n[_f] = I / C, n[_f + 1] = h / C, n[_f + 2] = k / C, n[_f + 3] = d / y;
    }
  }
}

function i(t) {
  return t ? {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t[3] / 255
  } : {
    r: 0,
    g: 0,
    b: 0,
    a: 0
  };
}

function l(t) {
  var e;
  return null == (e = t.data) ? void 0 : e.symbol;
}

function c(t) {
  return "CIMVectorMarker" === t.type || "CIMPictureMarker" === t.type || "CIMBarChartMarker" === t.type || "CIMCharacterMarker" === t.type || "CIMPieChartMarker" === t.type || "CIMStackedBarChartMarker" === t.type;
}

function u(t) {
  return "CIMGradientStroke" === t.type || "CIMPictureStroke" === t.type || "CIMSolidStroke" === t.type;
}

function s(t) {
  return "CIMGradientFill" === t.type || "CIMHatchFill" === t.type || "CIMPictureFill" === t.type || "CIMSolidFill" === t.type || "CIMWaterFill" === t.type;
}

function M(t) {
  return "CIMMarkerPlacementAlongLineRandomSize" === t.type || "CIMMarkerPlacementAlongLineSameSize" === t.type || "CIMMarkerPlacementAlongLineVariableSize" === t.type || "CIMMarkerPlacementAtExtremities" === t.type || "CIMMarkerPlacementAtMeasuredUnits" === t.type || "CIMMarkerPlacementAtRatioPositions" === t.type || "CIMMarkerPlacementOnLine" === t.type || "CIMMarkerPlacementOnVertices" === t.type;
}

var f = function f(t) {
  return t && t.toLowerCase().replace(/\s+/g, "-");
},
    p = function p(t) {
  return isNaN(t) || !t ? 0 : t;
};

export { a as _adjustTextCase, r as colorToArray, n as createLabelOverrideFunction, e as evaluateValueOrFunction, i as fromCIMColor, p as getValue, s as isCIMFill, c as isCIMMarker, M as isCIMMarkerStrokePlacement, u as isCIMStroke, o as resampleHermite, l as toCIMSymbolJSON, f as toKebabCase };